import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Drawer extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  postDesignedUnitData(data) {
    return this.httpService.post("Project/save-unit-designer", data, {
      headers,
    });
  }

  generateUnit(params) {
    return this.httpService.get("Project/template-generate-unit", {
      headers,
      params,
    });
  }

  getSettingUnit(params) {
    return this.httpService.get("Project/setting-tarahi-all", {
      headers,
      params,
    });
  }

  getProjectCountUnit(params) {
    return this.httpService.get("Project/count-unit", {
      headers,
      params,
    });
  }

  allPopWithBrand(params) {
    return this.httpService.get("Definition/all-pop-with-brand", {
      headers,
      params,
    });
  }

  getSizeProfile(params) {
    return this.httpService.get("Definition/size-profile-design", {
      headers,
      params,
    });
  }

  GetRokobCombo(params) {
    return this.httpService.get("Definition/combo-rokob-struct", {
      headers,
      params,
    });
  }

  GetRokobUnit(params) {
    return this.httpService.get("Project/rokob-unit-id", { headers, params });
  }

  GetAstanehPakhorErtefaCombo(params) {
    return this.httpService.get("Definition/list-ape", { headers, params });
  }

  setIdRefrenceUnit(data) {
    return this.httpService.post("Project/set-refrence-unit", data, {
      headers,
    });
  }

  GetRefrenceUnit(params) {
    return this.httpService.get("Project/refrence-unit", { headers, params });
  }

  GetTemplateLolaeeForStyle(params) {
    return this.httpService.get(
      "Definition/select-template-lolae-with-struct",
      { headers, params }
    );
  }

  GetInfoTemplateLolaeeForStyle(params) {
    return this.httpService.get("Definition/template-lola-tarkib", {
      headers,
      params,
    });
  }

  GetComboFomMastik(params) {
    return this.httpService.get("Definition/combo-foam-mastic", {
      headers,
      params,
    });
  }

  GetComboGlassWizard(params) {
    return this.httpService.get("Definition/combo-product-glass-all", {
      headers,
      params,
    });
  }

  GetComboTemplateWizard(params) {
    return this.httpService.get("Definition/select-com-template-wizard", {
      headers,
      params,
    });
  }

  GetInfoRebuildWizard(params) {
    return this.httpService.get("Project/rebuild-new-unit-wizard", {
      headers,
      params,
    });
  }

  getEqualGlass(params) {
    return this.httpService.get("definition/equal-glass-rail", {
      headers,
      params,
    });
  }

  postFoamMasticUnit(data) {
    return this.httpService.post("Project/set-fom-mastic-units", data, {
      headers,
    });
  }

  getListProfileRight(params) {
    return this.httpService.get("Definition/list-profile-right", {
      headers,
      params,
    });
  }

  getGlassDesign(params) {
    return this.httpService.get("Definition/glass-design", {
      headers,
      params,
    });
  }

  getBrandFitting(params) {
    return this.httpService.get("Definition/combo-brand-fitting-pop", {
      headers,
      params,
    });
  }

  getPopDesign(params) {
    return this.httpService.get("Definition/combo-pop-design", {
      headers,
      params,
    });
  }
  getFrameRightClick(params) {
    return this.httpService.get("Definition/property-frame-clickright", {
      headers,
      params,
    });
  }

  getSashRightClick(params) {
    return this.httpService.get("Definition/property-sash-clickright", {
      headers,
      params,
    });
  }
  getEdgeProfileDesign(params) {
    return this.httpService.get("Definition/edge-profile", {
      headers,
      params,
    });
  }

  getSpecialGroup(params) {
    return this.httpService.get("Definition/mulion-group-special", {
      headers,
      params,
    });
  }
  getSizeProfileDrawer(params) {
    return this.httpService.get("Definition/size-profile", {
      headers,
      params,
    });
  }
  getRailPanelData(params) {
    return this.httpService.get("Definition/bound-rail-panel", {
      headers,
      params,
    });
  }
  getPopPanelData(params) {
    return this.httpService.get("Definition/bound-lolaee-panel", {
      headers,
      params,
    });
  }
  selectUnitInDrawer(data) {
    return this.httpService.put("Project/selected-unit", data, { headers });
  }
}

const DrawerService = new Drawer();
export default DrawerService;
